import css from './PasswordExpiredForm.module.css';

import { useContext } from 'react';
import { UserContext } from '../../../context/userContext';
import { useForm } from '../../../hooks/useForm';
import DataForm from '../../Common/DataForm/DataForm';
import {
  ErrorCode,
  ForgotPasswordResult,
  FormStatus,
} from '../../../types/appTypes';

const PasswordExpiredForm = () => {
  const { user, forgotPassword } = useContext(UserContext);
  const { formState, setFormState } = useForm<{}>({
    initialFields: {},
  });

  const formSubmitHandler = async (event: React.FormEvent) => {
    event.preventDefault();

    setFormState({ status: FormStatus.Submitting });
    forgotPassword!(user!.customData.email).then((result) => {
      switch (result) {
        case ForgotPasswordResult.Success:
          setFormState({ status: FormStatus.Success });
          break;
        case ForgotPasswordResult.NotFound:
          setFormState({
            status: FormStatus.NotFound,
            error: {
              code: ErrorCode.notFound,
              message: 'A user was not found with that email',
            },
          });
          break;
        default:
          setFormState({
            status: FormStatus.Fail,
            error: {
              code: ErrorCode.unknown,
              message: 'An error occurred processing your request.',
            },
          });
          break;
      }
    });
  };

  return (
    <DataForm
      title='Password Expired'
      successMessage='An email has been sent with a link to set a new password.'
      submitErrorMessage={formState.error?.message}
      secondaryContainerClass={css.container}
      status={formState.status}
      onSubmit={formSubmitHandler}
    >
      <div className={css.instructions}>
        <p>
          Submit the form below and we will send you a link to change your
          password.
        </p>
        <p className={css.email}>Email: {user!.customData.email}</p>
      </div>
      <div className={css.actions}>
        <button type='submit'>Submit</button>
      </div>
    </DataForm>
  );
};

export default PasswordExpiredForm;
